<script setup lang="ts">
import { TableCell } from '~/components/cms/Table/Table.vue'

const props = defineProps<TableCell>()

/*
@TODO

    const { $modal, $parent } = useContext()

    const openPopup = (item) => {
      if (item) {
        const gaOptions = {
          group: `${$parent?.$props?.variant}: ${props.reference?.title}`,
          type: 'tooltip click',
        }
        $modal.slide(RichText, { content: item }, gaOptions)
      }
    }

    return { openPopup }
  },
  computed: {
    isTooltip() {
      return !!this.reference.content
    },
    value() {
      if (this.reference.value === true) {
        return 'Yes'
      }
      if (this.reference.value === false) {
        return 'No'
      }
      return this.reference.value
    },
  },
}

*/
</script>

<template>
  <div>
    <!-- <Link v-if="reference && reference.contentType === 'link'" v-bind="reference" />
    <Icon v-else-if="reference && reference.contentType === 'icon'" v-bind="reference" />
    <div v-else-if="reference && reference.contentType === 'productAttribute'" class="pdp-detail__container">
      <div>
        {{ reference.title }}
        <a class="pdp-detail__link" @click="openPopup(reference.content)">
          <img
            v-if="isTooltip"
            id="pdp-detail__link-icon-img"
            src="/icons/circle-question.svg"
            alt="link icon"
            tabindex="0"
            class="pdp-detail__link-icon focusable"
            @keyup.enter="openPopup(reference.content)"
          />
        </a>
      </div>
      <div>
        <label class="table-cell__value"> {{ value }}</label>
      </div>
    </div>
    <PanelSwitcher v-else-if="reference" :panel="reference" /> -->
    <span v-if="textValue" class="table-cell__text">{{ textValue }}</span>
  </div>
</template>

<style lang="postcss">
/*
@TODO

.pdp-detail__link-icon {
  font-size: theme-font-size(small);
  height: theme-font-size(small);
  font-weight: theme-font-weight(regular);
  cursor: pointer;
}

.pdp-detail__container {
  display: inline-grid;
  align-items: center;
  grid-template-columns: 50% 50%;
  width: 100%;
  column-gap: theme-spacing(4);
}

.table-cell__text {
  @apply leading-normal break-words;
}

.pdp-detail__link {
  @apply inline-block ml-1;
} */
</style>
